import { useMemo } from 'react';
import { createSafeContext } from '@mews/framework';
import { EnterpriseType, UserType } from './types';

interface UserContextProps {
    userType: UserType;
    enterpriseType: EnterpriseType;
}

export const { UserContextProvider, useUserContext } = createSafeContext<'UserContext', UserContextProps>(
    'UserContext'
);

export const UsersContextProvider: React.FC<React.PropsWithChildren<UserContextProps>> = ({
    userType,
    enterpriseType,
    children,
}) => {
    const userContextValue = useMemo(() => ({ userType, enterpriseType }), [userType, enterpriseType]);

    return <UserContextProvider value={userContextValue}>{children}</UserContextProvider>;
};
